export const COURSES_QUERY_KEY = 'courses';
export const COURSE_QUERY_KEY = 'course';
export const COURSE_RESOURCE_QUERY_KEY = 'course-resource';
export const COURSE_SLIDE_DECK_QUERY_KEY = 'course-slide-deck';
export const COURSE_QUIZ_QUERY_KEY = 'course-quiz';
export const HIGHLIGHTED_COURSES_QUERY_KEY = 'highlighted-courses';
export const SCORM_DISPATCH_URL_QUERY_KEY = 'scorm-dispatch-url';

export const LISTING_REQUEST_MAX_TAKE = 1000;
export const COURSES_LIST_CACHE_TIME = 5 * 60 * 1000;
